// import React from 'react'
// import { Navigate } from 'react-router-dom';

// export default function ProtectedRoute() {
//   return (
//     <div>

//     </div>
//   )
// }


import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('agriToken');

  return token ? children : <Navigate to="/admin" replace />;
  // return token ? <Navigate to="/dashboard" replace /> : <Navigate to="/admin" replace />;

};

export default ProtectedRoute;

